<template>
<div class="page">
    <Header title="课程介绍"></Header>
    <div class="header">
        <img class="img" v-if="dataSources.home_img" :src="dataSources.home_img" />
        <div class="desc">{{dataSources.desc}}</div>
        <div class="student-num td-fcc">{{dataSources.student_num || 0}}人在学</div>
    </div>
    <div class="body">
        <div class="title">课程详情</div>
        <div class="content" v-html="dataSources.content"></div>
    </div>
    <div class="footer">
        <div class="btn btn2" @click="openDialog">{{dataSources.is_buy_text}}</div>
    </div>
    <!-- 解锁课程 -->
    <van-dialog v-model="show" title="解锁课程" :showConfirmButton="false" :showCancelButton="false">
        <div class="form-box">
            <div class="tips">
                <span>咨询顾问：</span>
                <span v-if="service&&service.customer_service">{{service.customer_service.name}} {{service.customer_service.mobile}}</span>
                <span v-else>******</span>
            </div>
            <van-form @submit="onSubmit">
                <van-field v-model="ticket_no" label="门票编号：" placeholder="请输入门票编号" :rules="[{ required: true, message: '请输入门票编号' }]" />
                <van-field v-model="secret_key" label="兑换密钥：" placeholder="请输入兑换密钥" :rules="[{ required: true, message: '请输入兑换密钥' }]" />
                <div class="btn-box">
                    <van-button type="info" size="small" color="#6472e8" plain @click="cancelDialog">取消</van-button>
                    <van-button type="info" size="small" color="linear-gradient(205deg,#9cb2f4 1%, #9bb1f4 1%, #6472e8 84%)" native-type="submit">提交核验</van-button>
                </div>
            </van-form>
        </div>
    </van-dialog>
</div>
</template>

<script>
import Header from '@/components/Header'
import { mapGetters } from "vuex";
import Lockr from 'lockr'
export default {
    /** 组件挂载 */
    components: {
        'Header': Header
    },
    /** 计算 */
    computed: {
        ...mapGetters(["service"]),
    },
    /** 数据区 */
    data() {
        return {
            show: false,
            active: 0,
            subject_id: "",
            dataSources: {},
            ticket_no: "",
            secret_key: ""
        };
    },
    /** 挂载前 */
    created() {
        this.subject_id = this.$route.query.id
        this.requestData();
    },
    /** 方法 */
    methods: {
        // 请求数据
        async requestData() {
            let url = this.API.subject_detail;
            let params = {
                id: this.subject_id,
                token: this.Lockr.get('token')
            };
            let result = await this.$post(url, params);
            if (result.code === this.GLOBAL.SUCCESS_CODE) {
                this.dataSources = result.data
            } else {
                this.Message({
                    title: result.msg,
                });
            }
        },
        // 解锁开启弹窗
        openDialog() {

            let token = this.Lockr.get('token')
            console.log('token---->', token);
            if (!token) {
                return this.$emit(this.Constants.SHOWLOGINDIALOG, true);
            }

            if (this.dataSources.is_buy != 0) return
            if (this.dataSources.is_ticket == 1) {
                this.show = true
            } else {
                this.$router.push('/contactUs?type=1')
            }
        },
        cancelDialog() {
            this.show = false
        },
        // 解锁课程
        async onSubmit() {
            let url = this.API.do_ticket;
            let params = {
                id: this.subject_id,
                ticket_no: this.ticket_no,
                secret_key: this.secret_key
            };
            let result = await this.$post(url, params);
            if (result.code === this.GLOBAL.SUCCESS_CODE) {
                this.show = false
                this.Message({
                    title: result.msg
                })
            } else {
                this.Message({
                    title: result.msg,
                });
            }
        },
        // 跳转
        onPressNav(router, query = {}) {
            this.$router.push({
                path: '/' + router,
                query: query
            })
        }
    },
};
</script>

<style lang="less" scoped>
.page {
    min-height: 100vh;
    background-color: #fff;
}

.header {
    padding: 15px;
    position: relative;

    .img {
        width: 100%;
        display: block;
        margin-bottom: 10px;
    }

    .desc {
        font-size: 16px;
        color: #333;
        line-height: 1.5;
        text-align: justify;
        word-break: break-all;
    }

    .student-num {
        position: absolute;
        top: 20px;
        right: 20px;
        height: 26px;
        padding: 0 15px;
        border-radius: 15px;
        font-size: 12px;
        line-height: 1;
        color: #fff;
        background-color: rgba(0, 0, 0, 0.4);
    }
}

.body {
    padding: 15px;
    border-top: solid #f8f8f8 10px;

    .title {
        font-size: 18px;
        color: #333;
        font-weight: 500;
        margin-bottom: 10px;
    }

    .content {
        font-size: 16px;
        line-height: 2;
        padding-bottom: 100px;
        text-align: justify;
        word-break: break-all;

        /deep/ p {
            font-size: 16px !important;
        }

        /deep/ img {
            max-width: 100%;
        }
    }
}

.footer {
    left: 0;
    bottom: 0px;
    z-index: 10;
    width: 100%;
    padding: 15px;
    position: fixed;
    box-sizing: border-box;
    display: flex;
    background-color: #fff;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);

    .btn {
        flex: 1;
        height: 40px;
        background: linear-gradient(225deg, #9cb2f4, #6472e8);
        border-radius: 3px;
        line-height: 40px;
        text-align: center;
        font-size: 15px;
        color: #fff;
        font-weight: 500;
    }

    .btn1 {
        height: 38px;
        margin-right: 15px;
        background: #fff;
        border: 1px solid #7181EB;
        color: #7181EB;
    }
}

.form-box {
    padding: 20px;

    .tips {
        padding: 10px;
        border-radius: 4px;
        background-color: #f6faff;
        display: flex;
        justify-content: center;
        margin-bottom: 10px;

        span {
            font-size: 15px;
            font-weight: 400;
            color: #7181eb;
        }
    }

    /deep/ .van-cell {
        background-color: #f8f8f8;
        margin-bottom: 10px;
        border-radius: 4px;
    }

    /deep/ .van-field__label {
        font-weight: 500;
        width: auto;
    }

    /deep/ .van-field__error-message {
        display: none;
    }

    .btn-box {
        display: flex;
        justify-content: space-around;
        margin-top: 20px;

        /deep/ .van-button {
            width: 100px;
            border-radius: 4px;
            font-size: 15px;
        }
    }
}
</style>
